class PageTop {
  constructor(el, opt) {
    this.el = el;
    this.swipersInitialized = {}; // Swiper初期化のフラグ
    this.mvTextSwiper = null;
    this.currentVideoIndex = 0;
    if ($(this.el).length > 0) {
      this.event();
    }
    this.mvTextEle = '.js-mv';
    if ($(this.mvTextEle).length > 0) {
      this.mvTextSlice();
      this.mvTextSwiperInit();
      this.videoSyncSwiper();
    }
    if ($('.js-case-modal-swiper').length > 0) {
      this.modalSwiper();
    }
    if ($('.js-case-detail-image-swiper').length > 0) {
      this.articleImageSwiper();
    }
  }

  event() {
    // 画像切り替えトリガーのホバーイベント
    $('.js-img-change-trigger').hover(function () {
      let index = $(this).index();
      $('.js-img-change').removeClass('is-active');
      $('.js-img-change').eq(index).addClass('is-active');
    });

    // タブのクリックイベント
    document.querySelectorAll('.tab').forEach((tab, index) => {
      tab.addEventListener('click', (event) => this.showTabContent(event, `tab${index + 1}`));
    });

    // 最初のタブとSwiperを初期化
    this.showTabContent(null, 'tab1');
    $('.tab').eq(0).addClass('active');


    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(".animate-element",
      {
        opacity: 0,
        y: 50
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "ease.in",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".downtoup", // トリガーとなる要素
          start: "top 50%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none",
          markers: false
        },
        onComplete() {
          $('.animate-element').css({ 'opacity': '1', 'transform': 'translate(0)' });
        }
      }
    );

    gsap.fromTo(".bottom-up:not(.swiper-slide-duplicate)",
      {
        opacity: 0,
        y: 20
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "ease.in",
        stagger: 0.3, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".bottom-up", // トリガーとなる要素
          start: "top center", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none",
          markers: false
        },
        onComplete() {
          $('.bottom-up').css({ 'opacity': '1', 'transform': 'translate(0)' });
        }
      }
    );

    gsap.fromTo(".animate-image",
      {
        opacity: 0,
        x: -300,
        y: -300
      },
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 3,
        ease: "power2.out",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".line-animation", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    gsap.fromTo(".animate-image-last",
      {
        opacity: 0,
        x: 0,
        y: 10
      },
      {
        opacity: 1,
        y: 0,
        duration: 12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".line-animation", // トリガーとなる要素
          start: "top 30%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    gsap.fromTo(".animate-image-sp:not(.animate-image-last-sp)",
      {
        opacity: 0,
        x: -100,
        y: -250
      },
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 3,
        ease: "power2.out",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".line-animation-sp", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    // 最後の要素のアニメーション
    gsap.fromTo(".animate-image-last-sp",
      {
        opacity: 0,
        x: 0,
        y: 20
      },
      {
        opacity: 1,
        y: 0,
        duration: 12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".line-animation-sp", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );
  }

  initializeSwiper(container, scrollbarSelector, scrollbarGrowbarSelector, nextButton, prevButton, slidesPerView, breakpoints) {
    if (this.swipersInitialized[container]) return; // 初期化済みならリターン

    const scrollbar = document.querySelector(scrollbarSelector);
    const scrollbarGrowbar = document.querySelector(scrollbarGrowbarSelector);
    let scrollbarW, scrollbarDragW, progressRange;

    if (scrollbar) {
      new Swiper(container, {
        slidesPerView: slidesPerView,
        allowTouchMove: false,
        spaceBetween: 20,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 500,
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: scrollbarSelector,
          type: 'progressbar',
        },
        breakpoints: breakpoints,
        on: {
          init: (swiper) => {
            const totalSlidesLen = swiper.slides.length;
          },
          touchStart: (swiper, e) => {
            this.swiperTouchStartX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
          },
          touchEnd: (swiper, e) => {
            const tolerance = 150;
            const totalSlidesLen = swiper.slides.length;
            const diff = e.type === 'touchend' ? e.changedTouches[0].clientX - this.swiperTouchStartX : e.clientX - this.swiperTouchStartX;

            if (swiper.isBeginning && diff >= tolerance) {
              swiper.slideTo(totalSlidesLen - 1);
            } else if (swiper.isEnd && diff <= -tolerance) {
              setTimeout(() => {
                swiper.slideTo(0);
              }, 1);
            }
          },
        },
      });
      ;
      this.swipersInitialized[container] = true; // 初期化済みとしてフラグを立てる
    }
  }

  showTabContent(event, tabId) {
    if (event) {
      event.preventDefault(); // デフォルトのリンク動作を防ぐ
    }

    // すべてのタブとコンテンツを非アクティブ化
    var tabs = document.getElementsByClassName('tab');
    var contents = document.getElementsByClassName('tab-content');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('active');
    }
    for (var i = 0; i < contents.length; i++) {
      contents[i].classList.remove('active-content');
    }

    // クリックされたタブと対応するコンテンツをアクティブ化
    const currentTab = event ? event.currentTarget : document.querySelector(`.tab[data-tab="${tabId}"]`);
    if (currentTab) {
      currentTab.classList.add('active');
    }

    const activeContent = document.getElementById(tabId);
    if (activeContent) {
      activeContent.classList.add('active-content');
    }

    // Swiperの初期化
    if (tabId === 'tab1') {
      this.initializeSwiper('.interview-swiper', "#js-slider__scrollInterview", "#js-slider__scrollGrowbarInterview", '.swiper-button--next', '.swiper-button--prev', 1.5, { 768: { slidesPerView: 'auto' } });
      const slides = document.querySelectorAll('.works-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.works-swiper').dataset.loop ? document.querySelector('.works-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.works-swiper', "#js-slider__scrollWorks", "#js-slider__scrollGrowbarWorks", '.swiper-button-works--next', '.swiper-button-works--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    } else if (tabId === 'tab2') {
      const slides = document.querySelectorAll('.sun-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.sun-swiper').dataset.loop ? document.querySelector('.sun-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.sun-swiper', "#js-slider__scrollSun", "#js-slider__scrollGrowbarSun", '.swiper-button-sun--next', '.swiper-button-sun--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    } else if (tabId === 'tab3') {
      const slides = document.querySelectorAll('.drone-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.drone-swiper').dataset.loop ? document.querySelector('.drone-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.drone-swiper', "#js-slider__scrollDrone", "#js-slider__scrollGrowbarDrone", '.swiper-button-drone--next', '.swiper-button-drone--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    }
  }

  mvTextSwiperInit() {
    const textSwiperElemt = '.js-mv-text-swiper';
    this.mvTextSwiper = new Swiper(textSwiperElemt, {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChangeTransitionStart: () => {
          gsap.to('.js-mv-text-swiper .swiper-slide', {
            opacity: 0
          })
        },
        slideChange: () => {
          setTimeout(() => this.mvTextAnime(), 50);
        },
        resize: () => {
          this.updateSlideVisibility();
        }
      }
    })

  }

  videoSyncSwiper() {

    var videos = document.querySelectorAll('.js-mv-video video');
    this.currentVideoIndex = 0;

    // 最初のビデオを再生
    videos[this.currentVideoIndex].play();

    // ビデオ終了時に次のビデオを再生
    const playNextVideo = () => {
      // 現在のビデオを停止して非表示
      videos[this.currentVideoIndex].style.display = 'none';
      videos[this.currentVideoIndex].pause();
      videos[this.currentVideoIndex].currentTime = 0;

      // 次のビデオのインデックスを計算して再生
      this.currentVideoIndex = (this.currentVideoIndex + 1) % videos.length;
      videos[this.currentVideoIndex].style.display = 'block';
      videos[this.currentVideoIndex].play();

      this.mvTextSwiper.slideNext();

    }

    // すべてのビデオに 'ended' イベントリスナーを追加
    videos.forEach(function (video) {
      video.addEventListener('ended', playNextVideo);
    });
  }


  updateSlideVisibility() {
    // アクティブなスライドの取得
    const activeSlide = document.querySelector('.swiper-slide-active');

    // 全スライドの取得
    const allSlides = document.querySelectorAll('.js-mv-text-swiper .swiper-slide');

    // 全てのスライドを非表示にし、アクティブなスライドのみ表示
    allSlides.forEach(slide => {
      if (slide === activeSlide) {
        // アクティブなスライドは表示する
        gsap.to(slide, {
          opacity: 1,
          duration: 0
        });
      } else {
        // 非アクティブなスライドは非表示にする
        gsap.to(slide, {
          opacity: 0,
          duration: 0
        });
      }
    });
  }

  mvTextSlice() {
    let $container = $('.js-mv-text');

    let number = 0;
    $container.each(function () {
      number++;
      $(this).addClass('is-' + number);
      let html = $(this).html();
      let wrappedText = '';
      let isTag = false;

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<') {
          // タグの開始を検出
          let tagStart = i;
          while (html[i] !== '>' && i < html.length) {
            i++;
          }
          let tag = html.substring(tagStart, i + 1);

          // <br>タグ（クラス付きや属性付きも含む）を検出
          if (/^<br\s*\/?>/i.test(tag)) {
            wrappedText += tag; // <br>タグ全体をそのまま追加
          } else {
            wrappedText += tag; // 他のタグの場合もそのまま追加
          }
        } else {
          // テキストを1文字ずつ<span>で囲む
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });
  }


  mvTextAnime() {

    let tl = gsap.timeline();

    tl
      .to('.js-mv-text-swiper .swiper-slide-active', {
        opacity: 1
      })
      .fromTo('.js-mv-text-swiper .swiper-slide-active .js-mv-en', {
        opacity: 0,
        y: 20,
      }, {
        opacity: 1,
        y: 0,
      }, '+=0.5')
      .to(".js-mv-text", 1, {
        opacity: 1,
      },)
      .fromTo(".js-mv-text-swiper .swiper-slide-active .js-mv-text span", {
        opacity: 0,
        y: 30,
        duration: 1500,
      }, {
        opacity: 1,
        y: 0,
        stagger: 0.1 // スタグアニメーションの間隔
      }, '<=')
      .fromTo(".js-mv-text-swiper .swiper-slide-active .js-mv-txt", {
        opacity: 0,
        y: 20,
      }, {
        opacity: 1,
        y: 0,
      })
  }

  modalSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-modal-swiper');

    swiperElements.forEach((swiperEle, index) => {

      const parentSwiper = swiperEle.closest('.js-modal');
      const siblingElement = swiperEle.nextElementSibling;

      // 各スワイパーにユニークなナビゲーションクラスを付与
      const nextClass = `swiper-next-${index}`;
      const prevClass = `swiper-prev-${index}`;

      const nextEle = parentSwiper.querySelectorAll('.js-case-modal-swiper__next');
      nextEle.forEach((item) => {
        item.classList.add(nextClass);
      })
      const prevEle = parentSwiper.querySelectorAll('.js-case-modal-swiper__prev');
      prevEle.forEach((item) => {
        item.classList.add(prevClass);
      })

      // 各スワイパーのインスタンスを初期化
      const modalSwiper = new Swiper(swiperEle, {
        loop: false,
        allowTouchMove: false,
        navigation: {
          nextEl: `.${nextClass}`,  // ユニークな次ボタンクラスを参照
          prevEl: `.${prevClass}`,  // ユニークな前ボタンクラスを参照
        },
        init: index === 0
      });

      // スライド移動用の要素を取得し、クリックでスライドを移動
      const slideMoveEle = parentSwiper.querySelectorAll('.js-case-modal-to');
      slideMoveEle.forEach((item, key) => {
        item.addEventListener('click', () => {
          if (!modalSwiper.initialized) {
            modalSwiper.init();  // Swiperを初期化
          }
          const modalTo = item.dataset.key;
          modalSwiper.slideTo(modalTo, 0);  // 対応するスライドに移動
        });
      });
    });
  }


  articleImageSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-detail-image-swiper');
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.nextElementSibling;
      paginationElement.classList.add(paginationClass);

      const prevClass = `swiper-prev-${index}`;
      const nextClass = `swiper-next-${index}`;
      item.querySelector('.js-case-detail-image-swiper__prev').classList.add(prevClass);
      item.querySelector('.js-case-detail-image-swiper__next').classList.add(nextClass);

      new Swiper(item, {
        allowTouchMove: false,
        navigation: {
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`
        },
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          renderBullet: function (index, className) {
            const slides = this.slides;
            const slide = slides[index];
            const slideImage = slide.querySelector('img').src;  // スライドの画像URLを取得
            return `<div class="${className}"><img src="${slideImage}" ></div>`;
          },
        },
      });
    });
    const modalToglle = document.querySelectorAll('.js-swiper-init');
    modalToglle.forEach((item) => {
      item.addEventListener('click', () => {
        this.articleImageSwiper();
      })
    })
  }

}